import script from "./b-chart.vue?vue&type=script&lang=ts&setup=true"
export * from "./b-chart.vue?vue&type=script&lang=ts&setup=true"

import "./b-chart.vue?vue&type=style&index=0&id=35233e63&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\WebStorm\\tianshu-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35233e63"]])

export default __exports__